import axios, { type AxiosError } from "axios"
import { applyMockInterceptor } from "@/mocks/api-adapter"

const BASE_PATH = "/api/activities/strange-go-game"

export const actRequest = axios.create({
    baseURL: __ACT_SERVER_HOST
        ? `${__ACT_SERVER_HOST}${BASE_PATH}`
        : BASE_PATH,
    responseType: "json",
    timeout: 10000,
    withCredentials: true,
})

if (__MOCK_ENABLED) {
    applyMockInterceptor(actRequest)
}

actRequest.interceptors.request.use(
    (config) => {
        document.body.classList.add("wait")
        return config
    },
    (error) => {
        document.body.classList.remove("wait")
        return Promise.reject(error)
    },
)

actRequest.interceptors.response.use(
    (response) => {
        document.body.classList.remove("wait")
        return response.data
    },
    (error: AxiosError) => {
        document.body.classList.remove("wait")
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const resData = error.response?.data as any
        if (resData) {
            return {
                code: resData.code ?? error.response?.status ?? -1,
                message: resData.message ?? error.message,
                data: null,
            }
        }
        return {
            code: error.response?.status ?? -1,
            message: error.response?.statusText ?? error.message,
            data: null,
        }
    },
)
